// Auto-generated by pipeline
export const firebaseConfig = {
  "authDomain": "arrase-b2606.firebaseapp.com",
  "projectId": "arrase-b2606",
  "storageBucket": "arrase-b2606.appspot.com",
  "messagingSenderId": "782541928473",
  "appId": "1:782541928473:web:d575dd5e6afc8476d39288",
  "measurementId": "G-J1F37CLSLT",
  "apiKey": "AIzaSyC7jhNPgBBK-1zmfFg0E3GVMaRxZNs4FlA"
};
